import { render } from "./pnc_visits.vue?vue&type=template&id=05429bbc&scoped=true"
import script from "./pnc_visits.vue?vue&type=script&lang=js"
export * from "./pnc_visits.vue?vue&type=script&lang=js"

import "./pnc_visits.vue?vue&type=style&index=0&id=05429bbc&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05429bbc"]])

export default __exports__